// extracted by mini-css-extract-plugin
module.exports = {"root":"_5d24d292","isHidden":"_a4bde318","icon":"_13e48770"};